import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var i=r=>jsxs("svg",b(a({xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",viewBox:"0 0 16 16",fill:"none"},r),{children:[jsx("circle",{cx:"8",cy:"8",r:"8",fill:"#F4F4F4"}),jsx("circle",{cx:"8",cy:"8",r:"5",fill:"#D1D1D1"})]})),e=i;

export { e as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5UV6FHDP.mjs.map